






























































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { format } from 'quasar'
import { SlickItem } from 'vue-slicksort'
import colors from 'src/assets/colors'
import SlidePreviewTail from 'components/presenter/item/topic/viewer/PreviewTail.vue'

@Component({
  components: {
    SlickItem,
    SlidePreviewTail
  }
})
export default class ItemTopicSlidesEditorGridItem extends Vue {
  pad = format.pad
  colors = colors

  @Prop()
  readonly index!: number

  @Prop()
  readonly disabled!: boolean

  @Prop()
  readonly editable!: boolean

  @Prop()
  readonly slide!: Json

  @Prop()
  readonly groups!: Json

  @Prop()
  readonly selected!: Set<string> | null

  get isSelected () {
    return this.selected && this.selected.has(this.slide.id)
  }

  get size () {
    return this.$q.screen.lt.md ? 'sm' : 'md'
  }

  get sizesm () {
    return this.$q.screen.lt.md ? 'xs' : 'sm'
  }

  get group () {
    return this.groups[this.slide.group] || {}
  }
}
